import React, { ReactElement } from 'react';
import { PageProps } from 'gatsby';

import Link from 'src/components/Common/Link';
import Headline from 'src/components/CE/Headline';
import {
  DefinitionListDescription,
  DefinitionList,
  DefinitionListTerm,
  List,
  ListItem,
  Logo,
  LogoGrid,
  Picture,
  Testimonial,
  Text,
  TwoColumns,
  Video,
} from 'src/components/CE';

import ProjectLayout from 'src/layouts/ProjectLayout';

const Project = ({ location }: PageProps): ReactElement => (
  <ProjectLayout location={location}>
    <TwoColumns>
      <DefinitionList>
        <DefinitionListTerm>Kunde</DefinitionListTerm>
        <DefinitionListDescription>
          InNuce Solutions GmbH
        </DefinitionListDescription>
        <DefinitionListTerm>Typ</DefinitionListTerm>
        <DefinitionListDescription>
          Konzeption, Animation, Videoschnitt
        </DefinitionListDescription>
        <DefinitionListTerm>Zeitraum</DefinitionListTerm>
        <DefinitionListDescription>2015</DefinitionListDescription>
        <DefinitionListTerm>Kooperation mit</DefinitionListTerm>
        <DefinitionListDescription>
          <Link
            to="http://www.stellaschulze.de"
            title="Schulze* grafik & design"
            targetBlank
          >
            Schulze* grafik & design
          </Link>
        </DefinitionListDescription>
      </DefinitionList>
      <Text>
        {`Wussten Sie, dass viele Fuhrparkmanager einen harten Job haben? Falls nicht, fragen
        Sie sich wohl eher: **FUHRPARK-WAS?!**

        **Fuhrparkmanager** - das sind vielbeschäftigte Menschen, die für ihre Unternehmen
        große Fahrzeugflotten verwalten und das ist nicht immer einfach. Unser Kunde InNuce
        Solutions bietet zur Unterstützung **FleetScape IP** als Softwarelösung an und das
        macht Fuhrparkmanager glücklich.
        `}
      </Text>
    </TwoColumns>
    <TwoColumns>
      <Video
        link="https://www.youtube-nocookie.com/embed/EHxE-eDVHG4?rel=0&amp;showinfo=0"
        title="FleetScape IP Erklärfilm"
      />
      <Text>
        <Headline>Erklärfilm</Headline>
        {`
        Um die Software allen Interessierten etwas näher zu bringen, begleiten wir Klaus. Klaus
        ist Furhparkmanager und ein sympathischer Kerl, der in letzter Zeit leider etwas überarbeitet ist.
        Das alles ändert sich durch den Einsatz von FleetScape IP.

        Unser Ziel war es, den gestressten Leidensgenossen von Klaus Mut zu machen. Wir glauben, das
        ist uns gelungen!
        `}
      </Text>
    </TwoColumns>
    <TwoColumns>
      <Text>
        <Headline size={3}>Liebe zum Detail</Headline>
        {`In Absprache mit dem Kunden haben wir uns im Projekt schnell für einen bunten,
        sympathischen und minimalistischen **Illustrationsstil** entschieden. Ein wenig Liebe
        zum Detail durfte natürlich auch nicht fehlen. Ein gutes Beispiel dafür ist das
        **Facial Rig** für das Gesicht von Klaus.

        Witzig oder?

        Da der Film stark auf die Sympathie zu Klaus setzt, war eine
        aussagekräftige Mimik besonders wichtig. Mit dem Rig konnten wir schnell und effektiv
        mit verschieden Gesichtsausdrücken experimentieren, um Klaus zum Leben zu erwecken.

        **ES LEBT ⚡⚡🧟⚡⚡**`}
      </Text>
      <Picture
        src="projekte/innuce-solutions/innuce-klaus-rig.gif"
        alt="InNuce facial rig"
        caption="*Scham natürlich ;)"
      />
    </TwoColumns>
    <TwoColumns>
      <Headline size={2}>Aufgaben im Projekt</Headline>
      <Text>
        <List>
          <ListItem icon="fa-pencil">
            {' '}
            Erstellung Storyboard und Abnahme durch den Kunden
          </ListItem>
          <ListItem icon="fa-play"> Illustration und Animation</ListItem>
          <ListItem icon="fa-scissors"> Schnitt und Vertonung</ListItem>
          <ListItem icon="fa-bicycle">
            {' '}
            Lieferung Formate für Messe + Einbindung in Website
          </ListItem>
        </List>
      </Text>
    </TwoColumns>
    <LogoGrid>
      <Headline>Technologien</Headline>
      <Logo logoType="after_effects" />
      <Logo logoType="illustrator" />
      <Logo logoType="premiere" />
      <Logo logoType="photoshop" />
    </LogoGrid>
    <Testimonial picture="innuce-testimonial.png">
      <Headline>Testimonial</Headline>
      <Text>
        {`> "Wir haben Fröhlich ∧ Frei als eine Agentur erlebt, die Konzepte entwickelt, die nicht nur gefallen,
        sondern auch durchdacht sind. Dabei haben wir uns während der Projektphase als Kunde gut aufgehoben und
        verstanden gefühlt und konnten zusammen eine Leidenschaft für das Projekt entwickelt, die über das
        normale Maß hinausgeht und uns begeistert hat. Die Zusammenarbeit, die sich dadurch ergeben hat,
        war unkompliziert, zielführend und vor allem immer sehr persönlich."

        **Iris Luther**, Marketing Koordinatorin InNuce Solutions GmbH
        `}
      </Text>
    </Testimonial>
  </ProjectLayout>
);

export const frontmatter: ProjectPageFrontmatter = {
  browserTitle:
    'Erklärfilm, Animation, Video für Softwaresysteme und -prozesse',
  layoutColor: 'innuce-yellow',
  metaDescription:
    'Für die Softwarelösung FleetscapeIP von Innuce Solutions haben wir einen Erklärfilm erstellt. Storyboard, Animation und Schnitt sind unser Werk.',
  name: 'Klaus erklärt...',
  sorting: 65,
  title: 'InNuce Solutions',
  type: 'Video ∧ Animation',
};

export default Project;
